import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "@environments/environment";
import { WebLogger } from "@weps/shared-http";
import { initializeAppOtelBaggage } from "./otel-baggage-init";

function importScript(url: string, scriptType?: string, async?: boolean): void {
  const script = document.createElement("script");
  script["src"] = url;
  script["fetchpriority"] = "high";
  script["async"] = async !== undefined ? async : true;
  if (scriptType) {
    script["type"] = scriptType;
  }
  document.head.appendChild(script);
}

function loadAdobeService(Env: string, internal: boolean): void {
  sessionStorage.setItem("Env", Env);
  sessionStorage.setItem("internal", String(internal));
}

// Need to dynamically import script tag for vgn header
importScript(environment.vgnUrl);

// Load Adobe C3 service dynamically (async: false to guarantee execution order)
loadAdobeService(environment.gatekeeper_env, environment.internal);
importScript(environment.c3Url, undefined, false);
importScript("assets/scripts/c3.js", undefined, false);

// Load OTel CDN (sync to ensure instrumentation is active before Angular)
importScript(environment.otelCdnUrl, undefined, false);
initializeAppOtelBaggage();

// Initialize WebLogger before bootstrapping Angular to ensure it's available
// for web-vitals callbacks and early logging
void WebLogger.init({
  environment: environment.logger_environment as "engineering" | "production" | "test",
  region: environment.internal ? "internal" : "external",
  isProduction: environment.production,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    WebLogger.log({
      message: "Application bootstrap error",
      level: "error",
      payload: { error: err },
    });
  });
